module.exports = __webpack_public_path__ + "static/media/DOEPalaceEXTA0035_design_clean_v003.e726a8d2.png";